import React from 'react';

const statusColors = {
  Following: '#93c5fd',
  Waitlisted: '#fbbf24',
  Applied: '#eab308',
  Enrolled: '#22c55e',
  Declined: '#ef4444',
  Withdrawn: '#9ca3af',
  Completed: '#14b8a6',
};

export default function StatusPill({ status }) {
  const color = statusColors[status] || '#9ca3af';
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: '9999px',
      background: color,
      color: 'white',
      fontSize: 12,
      fontWeight: 600,
    }}>
      {status}
    </span>
  );
}



